module.exports = __webpack_public_path__ + "img/trip(11).84809eda.webp";